import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
interface Purchase {
  name: string;
  city: string;
}
export function SocialProofPopup() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const purchases: Purchase[] = [{
    name: 'Martín G.',
    city: 'Buenos Aires'
  }, {
    name: 'Lucía F.',
    city: 'Córdoba'
  }, {
    name: 'Santiago R.',
    city: 'Rosario'
  }, {
    name: 'Carolina M.',
    city: 'Mendoza'
  }, {
    name: 'Diego M.',
    city: 'Tucumán'
  }, {
    name: 'Valentina S.',
    city: 'La Plata'
  }, {
    name: 'Facundo L.',
    city: 'Mar del Plata'
  }, {
    name: 'Camila P.',
    city: 'Salta'
  }, {
    name: 'Nicolás B.',
    city: 'San Juan'
  }, {
    name: 'Florencia T.',
    city: 'Neuquén'
  }, {
    name: 'Matías C.',
    city: 'Santa Fe'
  }, {
    name: 'Agustina V.',
    city: 'Bahía Blanca'
  }];
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const interval = setInterval(showPopup, 10000);
    const initialTimeout = setTimeout(showPopup, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-107">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-108">
          <div className="bg-[#1e293b] border-2 border-yellow-400 rounded-lg shadow-2xl shadow-yellow-400/20 p-4" data-id="element-109">
            <div className="flex items-start gap-3" data-id="element-110">
              <div className="bg-yellow-400/90 p-2 rounded-full" data-id="element-111">
                <CheckCircle2Icon className="w-5 h-5 text-black" data-id="element-112" />
              </div>
              <div className="flex-1" data-id="element-113">
                <p className="font-bold text-white mb-1" data-id="element-114">
                  {currentPurchase.name} de {currentPurchase.city}
                </p>
                <p className="text-sm text-gray-300" data-id="element-115">
                  acaba de comprar el MegaPack KineEficiente
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}